import React from 'react';
import ImageGallerycallcenter from '../components/ImageGallerycallcenter';
import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCCALL = () => {
    const helplineBaseAmount = 900;

  const { stats, loading } = useStats();

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  const handleHelpLineClick = () => {
    handlePhoneClick('80-5545-5545');
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>

          <div className="about-us-container">
            <section className="activities-details">
              <div className="activity-intro">
                <h2>IRC Helpline</h2>
                <p>A bench of well-versed and knowledgeable Scholars answers the queries of callers from all over the globe, pertaining to any day-to-day issue in the light of Qur'an and authentic Sunnah, Alhamdulillaah.</p>
              </div>
              <ImageGallerycallcenter />

              {/* IRC Helpline */}
              <div className="activity-card">
                <div className="activity-header">
                  <h3>OUR HELP LINE SERVICES</h3>
                </div>
                <div className="activity-content">
                  <div className="clinic-card-container" style={{ position: 'relative', maxWidth: '800px', margin: '0 auto' }}>
                    {/* Large Help Line Button */}
                    <button 
                      className="helpline-button-large"
                      onClick={handleHelpLineClick}
                    >
                      <div className="helpline-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white">
                          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                        </svg>
                      </div>
                      <div className="helpline-content">
                        <div className="helpline-title">CALL NOW</div>
                        <div className="helpline-number">80-5545-5545</div>
                        <div className="helpline-subtitle">24/7 Support Available</div>
                      </div>
                    </button>

                    <div className="clinic-card">
                      <h4>IRC Helpline</h4>
                      <p><strong>Name:</strong> IRC Helpline</p>
                      <p>
                        <strong>Contact No: </strong>
                        <span
                          className="contact-number"
                          onClick={() => handlePhoneClick('80-5545-5545')}
                          style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                        >
                          80-5545-5545
                        </span>
                      </p>
                      <p><strong>Timings:</strong> 8:00 AM to 10:00 PM IST</p>
                      <p><strong>IVR Started On:</strong> 1-Jan-2018</p>
                      <p><strong>Total No of Calls:</strong> {formatNumber(stats.total_calls)} (till {formatDisplayDate(stats.call_centre_date)})</p>
                    </div>
                  </div>

                  <div className="activity-description" style={{ marginTop: '30px', textAlign: 'center' }}>
                    <p>Our help line provides authentic Islamic guidance on various matters including:</p>
                    <ul style={{ display: 'inline-block', textAlign: 'left' }}>
                      <li>Quranic interpretations</li>
                      <li>Hadith explanations</li>
                      <li>Fiqh (Islamic jurisprudence) matters</li>
                    </ul>
                  </div>
                </div>
                <IRCTVDonationCard
                  title="OUR HELP LINE SERVICES"
                  baseAmount={helplineBaseAmount}
                  subtitle="Your donation makes a difference"
                  description="Donate Us continue providing quality content and services to our community."
                  amount="₹5000"
                  purpose="Cause: SPONSER A DAY"
                />
              </div>
            </section>
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCCALL;

























// import React from 'react';
// import ImageGallerycallcenter from '../components/ImageGallerycallcenter';
// import IRCTVDonationCard from "./IRCTVDonationCard";
// import { useStats } from '../hooks/useStats';

// const IRCCALL = () => {
//   const { stats, loading } = useStats();

//   // Format date for display
//   const formatDisplayDate = (dateString) => {
//     if (!dateString) return '31-Jan-2025';
//     const date = new Date(dateString);
//     const day = date.getDate();
//     const month = date.toLocaleString('en-US', { month: 'short' });
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   // Format number with commas
//   const formatNumber = (num) => {
//     if (!num && num !== 0) return 'Loading...';
//     return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   };

//   const handlePhoneClick = (phoneNumber) => {
//     const cleanedNumber = phoneNumber.replace(/\D/g, '');
//     const telLink = `tel:${cleanedNumber}`;
//     window.location.href = telLink;
//   };

//   if (loading) return <div className="loading">Loading statistics...</div>;

//   return (
//     <>
//       <div className="about-us-container">
//         <section className="activities-details">
//           <button
//             onClick={() => window.history.back()}
//             style={{
//               marginBottom: '10px',
//               padding: '8px 10px',
//               backgroundColor: '#255fe8',
//               color: 'white',
//               border: 'none',
//               borderRadius: '5px',
//               cursor: 'pointer',
//               fontSize: '16px',
//               display: 'flex',
//               alignItems: 'center',
//             }}
//           >
//             ← Back to All Activities
//           </button>

//           <div className="about-us-container">

//             <section className="activities-details">
//               <div className="activity-intro">
//                 <h2>IRC Helpline</h2>
//                 <p>A bench of well-versed and knowledgeable Scholars answers the queries of callers from all over the globe, pertaining to any day-to-day issue in the light of Qur'an and authentic Sunnah, Alhamdulillaah.</p>
//               </div>
//               <ImageGallerycallcenter />

//               {/* IRC Helpline */}
//               <div className="activity-card">
//                 <div className="activity-header">
//                   <h3>OUR HELP LINE SERVICES</h3>
//                 </div>
//                 <div className="activity-content">
//                   <div className="clinic-card" style={{ maxWidth: '800px', margin: '0 auto' }}>
//                     <h4>IRC Helpline</h4>
//                     <p><strong>Name:</strong> IRC Helpline</p>
//                     <p>
//                       <strong>Contact No: </strong>
//                       <span
//                         className="contact-number"
//                         onClick={() => handlePhoneClick('80-5545-5545')}
//                         style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
//                       >
//                         80-5545-5545
//                       </span>
//                     </p>
//                     <p><strong>Timings:</strong> 8:00 AM to 10:00 PM IST</p>
//                     <p><strong>IVR Started On:</strong> 1-Jan-2018</p>
//                     <p><strong>Total No of Calls:</strong> {formatNumber(stats.total_calls)} (till {formatDisplayDate(stats.call_centre_date)})</p>
//                   </div>

//                   <div className="activity-description" style={{ marginTop: '30px', textAlign: 'center' }}>
//                     <p>Our help line provides authentic Islamic guidance on various matters including:</p>
//                     <ul style={{ display: 'inline-block', textAlign: 'left' }}>
//                       <li>Quranic interpretations</li>
//                       <li>Hadith explanations</li>
//                       <li>Fiqh (Islamic jurisprudence) matters</li>
//                       <li>Daily life issues in light of Shariah</li>
//                       <li>Marriage and family counseling</li>
//                       <li>Islamic finance queries</li>
//                     </ul>
//                   </div>
//                 </div>
//                 <IRCTVDonationCard
//                   title="OUR HELP LINE SERVICES"
//                   subtitle="Your donation makes a difference"
//                   description="Donate Us continue providing quality content and services to our community."
//                   amount="₹5000"
//                   purpose="Cause: OUR HELP LINE SERVICES"
//                 />
//               </div>
//             </section>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default IRCCALL;